import React,{useState,useEffect} from 'react';
import { Field, reduxForm ,touch,change} from 'redux-form';
import { connect } from 'react-redux';
import {AsyncPaginate} from 'react-select-async-paginate';
import Utils from '../../../lib/utils';
import renderField from '../../customInputs/renderField';
import renderSelect from '../../customInputs/renderSelect';
import FilterActions from '../../common/filterActions/FilterActions'
import { bindActionCreators } from 'redux';
import * as loadApplyOptions from '../../common/countyDropdownActions/loadOptions'
import * as applyActions from '../../common/countyDropdownActions/actions'
import _ from 'lodash';

let FilterSC = props => {

  let {
    title,
    keywordsLabel,
    keywordsPlaceholder,
    HCLabel,
    HCPlaceholder,
    SCStatusLabel,
    SCStatusPlaceholder,
    tradeLabel,
    tradePlaceholder,
    tierRatingLabel,
    tierRatingPlaceholder,
    stateLabel,
    statePlaceholder,
    maxSingleLabel,
    maxSinglePlaceholder,
    maxAggregateLabel,
    maxAggregatePlaceholder,
    vendorIdLabel,
    vendorIdPlaceholder,
    countryLabel,
    archivedLabel,
    insuranceStatusLabel,
    insuranceStatusPlaceholder
  } = props.local.strings.subcontractors.filter;
  const { insuranceStatusOptionsList } = props.local.strings.subcontractors.filterOptions;

  const SelectAsyncOptions = ({ input, meta, dispatch, ...props }) => {
    const touchedError = meta.touched && meta.error;
    const name = input.name;
    const baseClassName = `${props.className || ''} select-${name}`;
    const errorClassName = `${touchedError ? `${baseClassName}-error` : ''}`;
  
    return (
      <React.Fragment>
        <AsyncPaginate
          {...input}
          {...props}
          openMenuOnClick={true}
          closeMenuOnScroll={true}
          cacheOptions={true}
          pageSize={10}
          additional={{ page: 1 }}
          classNamePrefix="vk"
          className={`${baseClassName} ${errorClassName}`}
          menuPlacement="auto"
          onFocus={(_) => { }}
          onBlur={() => meta.dispatch(touch('FilterSC', name))}
          onChange={(newValue) => input.onChange(newValue)}
          captureMenuScroll={true}
          closeMenuOnSelect={true}
          debounceTimeout={300}
          loadOptionsOnMenuOpen={true}
        />
        {touchedError && (
          <span className="select-error-message field-validation-message">
            {meta.error}
          </span>
        )}
      </React.Fragment>
    );
  };
  const [selectedCountry,setselectedCountry] = useState(null)

  const resetStateValue = (value) => {
    props.dispatch(change(
      'FilterSC',
      'countryId',
      {value:value.value,label:value.label}
    ));
    if(selectedCountry !== value.value){
      props.dispatch(change(
        'FilterSC',
        'stateId',
        {value:null,label:''}
      ));
    }
    setselectedCountry(value.value)
  };
  const handleSelectState = (value) => {
    props.dispatch(change(
      'FilterSC',
      'stateId',value.value
    ));
  }
  // hc options
  const hcOptionsList = Utils.getOptionsList(HCPlaceholder, props.hc.list, 'name', 'id', 'name');
  // status options
  let statusOptionsList = Utils.getMultiVariateOptionsList(SCStatusPlaceholder, props.sc.subcontratorStatusWithCounts, 'Status', 'SubCount', 'Id').map(option => ({ value: option.value, label: option.withCountlabel, plainLabel: option.label }));
  statusOptionsList = statusOptionsList.slice(1);
  // const statusOptionsList = Utils.getOptionsList(SCStatusPlaceholder, props.sc.subcontratorStatus, 'Status', 'Id', 'Id');
  // trade options
  const tradeOptionsList = Utils.getOptionsList(null, props.sc.tradesForFilterList, 'description', 'id', 'orderIndex').map(option => ({ value: option.value, label: option.label }));
  // tier rates
  const tierRatesOptionsList = Utils.getOptionsList(null, props.sc.subcontratorTierRates, 'Name', 'Id', 'Id').map(option => ({ value: option.value, label: option.label }));
  // state options
  // const statesOptionsList = Utils.getOptionsList(statePlaceholder, props.register.geoStates, 'Name', 'ShortName', 'Name');
  const insuranceStatusOptions = Utils.getOptionsList(null, insuranceStatusOptionsList, 'label', 'value', 'value').map(option => ({ value: option.value, label: option.label }));

  const {handleSubmit} = props;
  const countryId = _.get(props, 'currentForm.FilterSC.values.countryId.value', null);
  const ArchivedOptions = [{ label: 'False', value: false },{ label: 'True', value: true }]

  return (
    <form
      onSubmit={handleSubmit}
      className="list-view-filter-form filter-sc-list" >
      <h2 className="list-view-filter-title">{title}</h2>
      <div className="container-fluid filter-fields">
        <div className="row sc-filter-row">

          <div className="col-md-3 col-sm-12 no-padd">
            <div className="admin-form-field-wrapper keyword-field">
              <label htmlFor="keywords">{keywordsLabel}: </label>
              <Field
                name="keywords"
                type="text"
                placeholder={`--${keywordsPlaceholder}--`}
                component={renderField}
                className="tags-input"
              ></Field>
            </div>
          </div>

          {
            !props.fromHCtab && (
              <div className="col-md-3 col-sm-12 no-padd" >
                <div className="admin-form-field-wrapper ass-hc-field">
                  <label htmlFor="associatedHCs">{HCLabel}: </label>
                  <div className="select-wrapper">
                    <Field
                      name="associatedHCs"
                      component={renderSelect}
                      options={hcOptionsList} />
                  </div>
                </div>
              </div>
            )
          }

          <div className="col-md-3 col-sm-12 no-padd" >
            <div className="admin-form-field-wrapper status-field">
              <label htmlFor="status">{SCStatusLabel}: </label>
              <div className="select-wrapper">
                <Field
                  name="status"
                  component={SelectAsyncOptions}
                  options={statusOptionsList}
                  isMulti
                  placeholder={`--${SCStatusPlaceholder}--`}
                />
              </div>
            </div>
          </div>

          <div className="col-md-3 col-sm-12 no-padd" >
            <div className="admin-form-field-wrapper trade-field">
              <label htmlFor="trade">{tradeLabel}: </label>
              <div className="select-wrapper">
                <Field
                  name="trade"
                  isMulti
                  component={SelectAsyncOptions}
                  placeholder={`--${tradePlaceholder}--`}
                  options={tradeOptionsList} />
              </div>
            </div>
          </div>

          <div className="col-md-3 col-sm-12 no-padd">
            <div className="admin-form-field-wrapper keyword-field">
              <label htmlFor="vendorId">{vendorIdLabel}: </label>
              <Field
                name="vendorId"
                type="text"
                placeholder={`--${vendorIdPlaceholder}--`}
                component={renderField}
                className="tags-input"
              ></Field>
            </div>
          </div>

        </div>

        <div className="row sc-filter-row">

          <div className="col-md-3 col-sm-12 no-padd" >
            <div className="admin-form-field-wrapper tier-rating-field">
              <label htmlFor="tierRating">{tierRatingLabel}: </label>
              <div className="select-wrapper">
                <Field
                  name="tierRating"
                  isMulti
                  component={SelectAsyncOptions}
                  placeholder={`--${tierRatingPlaceholder}--`}
                  options={tierRatesOptionsList} />
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-12 no-padd" >
            <div className="admin-form-field-wrapper state-field">
              <label htmlFor="countryId">
                {countryLabel}:
              </label>
              <Field
                name="countryId"
                onChange={(values)=>resetStateValue(values)}
                type="text"
                required={true}
                isMulti
                component={SelectAsyncOptions}
                placeholder='Select Country'
                loadOptions={props.actions.loadCountries(props)}
              />
            </div>
          </div>
          {countryId ? 
          <div className="col-md-3 col-sm-12 no-padd" >
            <div className="admin-form-field-wrapper state-field">
              <label htmlFor="stateId">{stateLabel}: </label>
              <div className="select-wrapper">
                <Field
                  name="stateId"
                  type="text"
                  required={true}
                  component={SelectAsyncOptions}
                  placeholder='Select State'
                  cacheUniqs={[selectedCountry]}
                  onChange={(value)=>handleSelectState(value)}
                  loadOptions={props.actions.loadStates(props,selectedCountry)}
                />
                </div>
              </div>
            </div>
          :null}
          
          <div className="col-md-3 col-sm-12 no-padd" style={{display:'none'}}>
            <div className="admin-form-field-wrapper max-single-field">
              <label htmlFor="maxSingle">{maxSingleLabel}: </label>
              <Field
                name="maxSingle"
                type="text"
                placeholder={`--${maxSinglePlaceholder}--`}
                component={renderField}
                className="tags-input"
              ></Field>
            </div>
          </div>

          <div className="col-md-3 col-sm-12 no-padd" style={{display:'none'}}>
            <div className="admin-form-field-wrapper max-aggregate-field">
              <label htmlFor="maxAggregate">{maxAggregateLabel}: </label>
              <Field
                name="maxAggregate"
                type="text"
                placeholder={`--${maxAggregatePlaceholder}--`}
                component={renderField}
                className="tags-input"
              ></Field>
            </div>
          </div>
          <div className="col-md-3 col-sm-12 no-padd">
            <div className="admin-form-field-wrapper archived-field">
              <label htmlFor="archived">{archivedLabel}: </label>
              <div className="select-wrapper">
                <Field
                  name="archived"
                  component={renderSelect}
                  options={ArchivedOptions}
                />
              </div>
            </div>
          </div>
         {props.showInsuranceStatus && (
              <div className="col-md-3 col-sm-12 no-padd">
                <div className="admin-form-field-wrapper archived-field">
                  <label htmlFor="insuranceStatusId">{insuranceStatusLabel}: </label>
                  <div className="select-wrapper">
                    <Field
                      name="insuranceStatusId"
                      component={SelectAsyncOptions}
                      options={insuranceStatusOptions}
                      isMulti
                      placeholder={`--${insuranceStatusPlaceholder}--`}
                    />
                  </div>
                </div>
              </div>
          )}
          <FilterActions
            filtersSaveCallback={() => props.filtersSaveCallback(_.get(props, 'currentForm.FilterSC.values', {}))}
            filtersDeleteCallback={props.filtersDeleteCallback}
            filtersResetCallback={props.filtersResetCallback}
            formName={props.form}
            dispatch={props.dispatch}
          />
        </div>
      </div>
    </form>
  );
}

FilterSC = reduxForm({
  form: 'FilterSC'
})(FilterSC);

const mapStateToProps = (state, ownProps) => {
  return {
    register: state.register,
    hc: state.hc,
    sc: state.sc,
    local: state.localization,
    currentForm: state.form
  }
};
const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      ...bindActionCreators(applyActions, dispatch),
      ...loadApplyOptions
    }
  };
};

export default connect(mapStateToProps,mapDispatchToProps)(FilterSC);
